import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

/** Chip sized to body2 text instead of a fixed height, for sitting inline with a row's label. */
export const InlineChip = styled(Chip)(({ theme }) => ({
  height: 'initial',
  fontSize: theme.typography.body2.fontSize,
}));
